import { ADMIN_FAQ_EDIT } from './index';
import { Action } from '../action';
import { FaqInfo } from '@shared/core';

export class AdminFaqEditInitAction implements Action {
	readonly type = ADMIN_FAQ_EDIT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqEditDestroyAction implements Action {
	readonly type = ADMIN_FAQ_EDIT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqEditCancelAction implements Action {
	readonly type = ADMIN_FAQ_EDIT.CANCEL;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqEditClickBackAction implements Action {
	readonly type = ADMIN_FAQ_EDIT.CLICK_BACK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqEditSubmitAction implements Action {
	readonly type = ADMIN_FAQ_EDIT.SUBMIT;
	constructor(
		public payload: FaqInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqEditSubmitSuccessAction implements Action {
	readonly type = ADMIN_FAQ_EDIT.SUBMIT_SUCCESS;
	constructor(
		public payload: FaqInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqEditSubmitFailureAction implements Action {
	readonly type = ADMIN_FAQ_EDIT.SUBMIT_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
